import React from "react";
import './WorldCollection.css';
import TopLeftBracket from './../../../../images/toprightbracket.png'
import GreenLeftBracket from './../../../../images/greentopleftbracket.png'
import GreenMedal from './../../../../images/greenmedal.png'
import artistnamesubmitted from './../../../../images/artistnamesubmitted.png'
import WorldCollectionImg5 from './../../../../images/worldcollectionimg5.png'
import WorldCollectionImg6 from './../../../../images/worldcollectionimg6.png'
import WorldCollectionBullet from './../../../../images/worldcollectionbullet.png'
import WorldCollectionImg8 from './../../../../images/worldcollectionimg8.png'
import WorldCollectionImg9 from './../../../../images/worldcollectionimg9.png'
import WorldCollectionMic from './../../../../images/worldcollectionmic.png'
import GreenArrow from './../../../../images/greenarrowdown.png'
import GreenBullet from './../../../../images/worlcollectiongreenbullet.png'
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import WorldCollectionHybrid from "../../../Hybrid/WorldCollectionHybrid";
import ScrollToTop from "../../../Hybrid/ScrollToTop";

function WorldCollection({hidedashboard,nav}) {
    const [name,setName] = useState("")
    const [email,setEmail] = useState("")
    const [projectName,setProjectName] = useState("")
    const [projectNotes,setProjectNotes] = useState("")
    const [spotifyProfileLink,setSpotifyProfileLink] = useState("")
    const navigate = useNavigate()
    const myRef = useRef(null);
    const [formsubmitted,setFormSubmitted] = useState(false)

    // function topFunction() {
    //     document.body.scrollTop = 0; // For Safari
    //     document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    //     console.log("Fired here")
        
    //   }

    // var myfun = function(ele){
    //     let offsetTop  = document.getElementById(ele).offsetTop;
    //     var right = document.getElementById("#WCContainer");
    //     window.scrollTo({
    //         top: offsetTop-0, 
    //         behavior: "smooth"
    //     });
    // }

    
    useEffect(()=>{
        // topFunction()
        // myfun("WCContainer")
        // myRef.current.scrollTo({
        //     top: 0, // Scroll to 100 pixels from the top
        //     left: 0,
        //     behavior: 'smooth' // Optional for smooth scrolling
        //   });
        // hidedashboard(false)
        // setTimeout(() => {
        //     window.scrollTo(0, 0);
        //   }, 0.1);
    },[]) 

    return (
       <div id="WCContainer"  ref={myRef}>
  

            {/* <span className="WeWorkFor" style={{position:'absolute',top:'73em',width:'100%',zIndex:'10'}}>
                        WE WORK FOR <span style={{color:'#81FF95',backgroundColor:'rgba(0,0,0,50%)',paddingLeft:'0.25em',paddingRight:'0.25em'}}>LEADING ARTISTS</span>
            </span> */}
         
     
        
        

        <div>
        <ScrollToTop/>
        <WorldCollectionHybrid/>

        {
            !formsubmitted &&
            <div  id="redirecttoform" style={{
                backgroundColor:`rgba(0,0,0,10%)`, 
                backgroundImage:'linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0.42) 0.01%, #100101 100%)',
                height:'70em',
                width:'100%',
                backgroundSize:'cover',
                display:'flex',
                flexDirection:'column',
                alignItems:'center'
         }}>
             
             <div className="SubmitYourProject">Submit Your Project Details</div>
             <div className="FillOutForm">Fill out the form with your project details to help us understand your vision.</div>
             
             <div className="WCFormHeader">Name</div>
             <input
                         value={name}
                         onChange={e =>{setName(e.target.value);}} 
                         className='WCFormInput'
                         type='text'
                        
                         // style={{marginLeft:'4.8em'}}
                         />
             <div className="WCFormHeader">Email</div>
             <input
                         value={email}
                         onChange={e =>{setEmail(e.target.value);}} 
                         className='WCFormInput'
                         type='text'
                        
                         // style={{marginLeft:'4.8em'}}
                         />
             <div className="WCFormHeader">Project Name</div>
             <input
                         value={projectName}
                         onChange={e =>{setProjectName(e.target.value);}} 
                         className='WCFormInput'
                         type='text'
                        
                         // style={{marginLeft:'4.8em'}}
                         />
             <div className="WCFormHeader">Project Notes</div>
             <textarea  rows="4" cols="50" className='WCtextarea' onChange={e =>{setProjectNotes(e.target.value);}}   >
                         {projectNotes}
             </textarea>
             <div className="WCFormHeader">Spotify Profile Link</div>
             <input
                         value={spotifyProfileLink}
                         onChange={e =>{setSpotifyProfileLink(e.target.value);}} 
                         className='WCFormInput'
                         type='text'
                        
                         // style={{marginLeft:'4.8em'}}
                         />
 
             <div className="WCFormSubmit" onClick={()=>{setName("");setEmail("");setProjectName("");setProjectNotes("");setSpotifyProfileLink("");setFormSubmitted(true); }}>
               SUBMIT
             </div>
 
             {/* <div style={{display:'flex',flexDirection:'row',marginTop:'1.5em'}}>
                 <div style={{width:'10px',height:'3px',marginRight:'12px',backgroundColor:'#868284'}}/>
                 <div style={{width:'10px',height:'3px',marginRight:'12px',backgroundColor:'#868284'}}/>
                 <div style={{width:'44px',height:'3px',marginRight:'12px',backgroundColor:'#868284'}}/>
             </div> */}
         </div>
        }

        {
            formsubmitted &&
            <div  id="redirecttoform" style={{
                backgroundColor:`rgba(0,0,0,10%)`, 
                backgroundImage:'linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0.42) 0.01%, #100101 100%)',
                height:'70em',
                width:'100%',
                backgroundSize:'cover',
                display:'flex',
                flexDirection:'column',
                alignItems:'center',
                justifyContent:'center'
         }}>
            <img src={artistnamesubmitted} style={{width:'2.5em',height:'2.5em'}}/> 
            <div className="WCFromH1">Thank You</div>
            <div className="WCFromH2">Your project details were submitted successfully on September 9, 2024.  We will get back to you soon!</div>
            <span className="WCFromH2">For any further inquiries, please contact us at <a href="mailto:support@n3rve.com" target="_blank" style={{textDecoration:'underline',color:'#C7A5FF'}} className="WCFromH2">support@nerve.com</a>.</span>
         </div>
        }
      
        </div>

        <div style={{
                backgroundImage:`url(${WorldCollectionImg5})`, 
                height:'5.43em',
                // height:'50px',
                width:'100%',
                backgroundSize:'cover',
                display:'flex',
                flexDirection:'row',
                alignItems:'center',
                justifyContent:'center'
        }}>
            <img src={WorldCollectionMic}/>
            <div className="WCFooterTxt">World Collections</div>
            <div className="WCFooterCopyright">2024© All rights reserved</div>
        </div>

      
       </div>
      
    );
}

export default WorldCollection;